import script from "./cashDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./cashDrawer.vue?vue&type=script&setup=true&lang=js"

import "./cashDrawer.vue?vue&type=style&index=0&id=a65fb234&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a65fb234"]])

export default __exports__